import { useWatch, useFormContext } from "react-hook-form";

export const useToggleAllUnits = (
  fields: { name: string; valuePrefix: string; type: "weight" | "length" }[]
): {
  selectedUnit: "imperial" | "metric";
  toggleAllUnits: (unit: "imperial" | "metric") => void;
} => {
  const { setValue } = useFormContext();

  const selectedUnit = fields
    // We know that these hooks will always be called in the same order
    // eslint-disable-next-line react-hooks/rules-of-hooks
    .map(({ name }) => useWatch({ name }))
    .reduce((result, value) => {
      if (result === null || !value) return null;
      const currUnit = ["lbs", "in"].includes(value.split("-").pop())
        ? "imperial"
        : "metric";
      return result === undefined || result === currUnit ? currUnit : null;
    }, undefined);

  const toggleAllUnits = (unit: "imperial" | "metric") => {
    const units = {
      weight: unit === "imperial" ? "lbs" : "kg",
      length: unit === "imperial" ? "in" : "cm",
    };
    fields.forEach(({ name, valuePrefix, type }) => {
      setValue(name, `${valuePrefix}${units[type]}`);
    });
  };

  return { selectedUnit, toggleAllUnits };
};
